module.exports = __webpack_public_path__ + "media/store/fonts/NouvelleGrotesque-Medium-f31c38e048ab7edaea6772010d32e1fc.otf";